module.exports = __webpack_public_path__ + "img/m12.e20358b.jpg";